module.exports = __webpack_public_path__ + "img/ms-add-account1.c95b320f.png";